import React from "react";
import { FiSearch, FiHeart, FiUser, FiShoppingCart } from "react-icons/fi";
import { Link, useLocation } from "react-router-dom";

const Header = () => {
  const location = useLocation();

  return (
    <header className="w-full px-6 py-5 shadow-md sticky top-0 z-50 bg-white">
      <div className="max-w-[85rem] mx-auto flex items-center justify-between font-commissioner">
        <div className="flex items-center">
          <img src="/logo.png" alt="logo" className="h-8" />
        </div>

        <nav className="hidden md:flex items-center space-x-9">
          {[
            { path: "/", text: "HOME" },
            { path: "/Women", text: "WOMEN" },
            { path: "/Men", text: "MEN" },
            { path: "/Youth", text: "YOUTH" },
            { path: "/Kids", text: "KIDS" },
            { path: "/Babies", text: "BABIES" },
            { path: "/sale", text: "SALE" },
            { path: "/customization", text: "CUSTOMIZATION" },
          ].map(({ path, text }) => (
            <Link
              key={path}
              to={path}
              className={`relative group text-lg ${
                location.pathname === path
                  ? "font-semibold text-black"
                  : "font-normal text-gray-600 hover:text-black transition-colors duration-300"
              }`}
            >
              {text}
              <div
                className={`absolute -bottom-[76%] left-0 w-full h-1 rounded-t-md ${
                  location.pathname === path
                    ? "bg-[#8860D0]"
                    : "bg-transparent group-hover:bg-[#8860D0] transition-all duration-300"
                }`}
              />
            </Link>
          ))}
        </nav>

        <div className="flex items-center space-x-5">
          {[
            { Icon: FiSearch, path: "/search" },
            { Icon: FiHeart, path: "/wishlist" },
            { Icon: FiUser, path: "/account" },
            { Icon: FiShoppingCart, path: "/cart" },
          ].map(({ Icon, path }) => (
            <Link to={path} key={path} className="relative group">
              <Icon
                className={`w-5 h-5 cursor-pointer ${
                  location.pathname === path
                    ? "text-[#8860D0] w-6 h-6"
                    : "text-black hover:text-[#8860D0] hover:scale-110 transition-all duration-300"
                }`}
              />
            </Link>
          ))}
        </div>
      </div>
    </header>
  );
};

export default Header;
